import headerImg from '../../../assets/serviceHeader.svg'

import img1 from '../../../assets/dummy1.avif'
import img2 from '../../../assets/dummy2.avif'
import img3 from '../../../assets/dummy3.avif'

import backend from '../../../assets/services-web-App/backend.svg'
import designer from '../../../assets/services-web-App/designer.svg'
import frontend from '../../../assets/services-web-App/frontend.svg'
import product from '../../../assets/services-web-App/product.svg'
import quality from '../../../assets/services-web-App/quality.svg'

import support from '../../../assets/services-web-App/support.svg'
import prototype from '../../../assets/services-web-App/prototype.svg'
import planning from '../../../assets/services-web-App/planning.svg'
import devops from '../../../assets/services-web-App/devops.svg'
import deployment from '../../../assets/services-web-App/deployment.svg'

import portals from '../../../assets/services-web-App/portals.svg'
import enterprise from '../../../assets/services-web-App/enterprise.svg'
import webConsulting from '../../../assets/services-web-App/web-consulting.svg'
import cloudBased from '../../../assets/services-web-App/cloud-based.svg'
import progressive from '../../../assets/services-web-App/progressive.svg'
import supplyChain from '../../../assets/services-web-App/supply-chain.svg'

import decision from '../../../assets/services-web-App/decision.svg'
import experience from '../../../assets/services-web-App/experience.svg'
import problemSolver from '../../../assets/services-web-App/problemSolver.svg'
import myimg from '../../../assets/spirtual.jpg'


import img from '../../../assets/services/img.svg'


import myimg1 from '../../../assets/services-web-App/tech/img1.svg'
import myimg2 from '../../../assets/services-web-App/tech/img2.svg'
import myimg3 from '../../../assets/services-web-App/tech/img3.svg'
import img4 from '../../../assets/services-web-App/tech/img4.svg'
import img5 from '../../../assets/services-web-App/tech/img5.svg'
import img6 from '../../../assets/services-web-App/tech/img6.svg'
import img7 from '../../../assets/services-web-App/tech/img7.svg'
import img9 from '../../../assets/services-web-App/tech/img9.svg'
import img10 from '../../../assets/services-web-App/tech/img10.svg'
import img11 from '../../../assets/services-web-App/tech/img11.svg'
import img12 from '../../../assets/services-web-App/tech/img12.svg'
import img13 from '../../../assets/services-web-App/tech/img13.svg'
import img14 from '../../../assets/services-web-App/tech/img14.svg'
import img15 from '../../../assets/services-web-App/tech/img15.svg'
import img16 from '../../../assets/services-web-App/tech/img16.svg'
import img17 from '../../../assets/services-web-App/tech/img17.svg'
import img18 from '../../../assets/services-web-App/tech/img18.svg'
import img19 from '../../../assets/services-web-App/tech/img19.svg'
import img20 from '../../../assets/services-web-App/tech/img20.svg'
import img22 from '../../../assets/services-web-App/tech/img22.svg'
import img23 from '../../../assets/services-web-App/tech/img23.svg'
import img24 from '../../../assets/services-web-App/tech/img24.svg'


import review from '../../../assets/dummyreview.png'


export const headerData = {
    title1: 'Custom Ebook Writing ',
    title2: 'Development Services',
    desc: 'We are a leading custom Ebook Writing  development company that creates scalable Ebook Writing  with high-quality standards. Thoroughly examining your preferences, requirements and expectations, our community of 500+ developers deliver top-notch web app development services to enhance your customer retention and boost brand equity. Have a look at our customer-centric services:',
    points: [
        'Daily collaborative meetings with product managers',
        'Free full-cycle quality assurance',
        'Wallet-friendly engagement models to hire developers'
    ],
    img: headerImg
}

export const BenefitsData = {
    title1: 'Kickstart Your Project with Our Personalized',
    title2: 'Ebook Writing  Development Services',
    desc: 'As the leading and trusted development company all over the world, we offer a personalized package of value-added services.',
    cards: [
        {
            title: 'Pocket-Friendly Services',
            desc: 'End up saving thousands of dollars with our exclusive and customized web application development services, which include a 7-day trial, experienced product managers, and full-cycle application testing and debugging.'
        },
        {
            title: 'Full Transparency',
            desc: 'Track the progress of the best web application development process with ease. A daily meeting with our product managers will keep you in the loop, treating your feedback as a valuable insight to deliver a bug-free final product.'
        },
        {
            title: 'Community of large Tech Veterans',
            desc: 'Codezone has hands-on expertise in web application development services and a thriving community of large developers that have achieved 97% client satisfaction across sectors such as Healthcare, Fintech, and more!'
        },
        {
            title: 'Specialized in Most Advanced Tech Stack',
            desc: 'Utilize the expertise of our proficient developers who have a strong grasp on the most popular programming languages, frameworks, databases, and other toolkit suites.'
        },
        {
            title: '100% Confidentiality As Promised',
            desc: 'You may be confident in the secrecy of your project! Our web app development team prioritizes cutting-edge technology and techniques to safeguard your data and other essential information.'
        },
    ]
}

export const recentworkdata = {
    title1: 'Our Recent',
    title2: 'Work',
    sliderData: [
        {
            title: 'dummy 1',
            img: [img1],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 2',
            img: [img2],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 3',
            img: [img3],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'The Spiritual Balance',
            img: [myimg],
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://drive.google.com/file/d/1fxOJCit_h8CgXrGVhPqWTCPWHs_665hE/view?usp=share_link'

        },

    ]
}

export const SuccessDrivenData = {
    title1: 'Build A Success-Driven Development Team To',
    title2: 'Protect Your Project Scope',
    desc: 'Prevent scope creep, frequent delays and unplanned changes by building a development team. Here’s what a success-driven development team looks like.',
    cards: [
        {
            title: 'Conveys Informations',
            desc: "An ebook cover can give readers an idea of what the ebook is about, including the genre, tone, and message.",
            img: frontend
        },
        {
            title: 'Sets Expectations',
            desc: "A high-quality ebook cover can set readers' expectations for the quality of the writing and the overall reading experience.",
            img: backend
        },
        {
            title: 'Increases Sales',
            desc: 'A compelling ebook cover can lead to more sales, as readers are more likely to purchase an ebook that looks professional and engaging.',
            img: product
        },
    ]
}

export const developmentProcessData = {
    title1: 'A Snapshot Of Our Ebook Writing ',
    title2: 'Development Process',
    desc: "Plan, design, develop, test and roll out each version of your web application with zero downtime.",
    processNames: ['Planning', 'Design', 'Prototype', 'Development', 'Software Quality Assurance', 'DevOps Services', 'Support & Maintenance'],
   processInfo : [
    {
        title: 'Planning',
        desc: 'Outline all procedures and activities necessary to ensure project success and develop a complete set of plans to manage the project from this phase till project completion. It provides a clear structure of scope, deliverables, processes, budget, tech stack and timeline.',
        img: planning,
        link : '/contact-us'
    },
    {
        title: 'Design',
        desc: 'To create a marketable product, refine your ideas through market research validation. Save expenses and eliminate risks by working with our focused web application development team that moves smoothly through numerous iterations and launches high-functioning prototypes via a streamlined MVP development approach.',
        img: prototype,
        link : '/ui-ux-design'
    },
    {
        title: 'Development',
        desc: 'With our well-established bespoke web application development services, your brand will stand out from the crowd. Build safe, scalable, accessible, and custom software solutions with our specialized SCRUM team - tailored to your firm’s specifications and market expectations.',
        img: deployment,
        link : '/'

    },
    {
        title: 'Software Quality Assurance',
        desc: 'Reduce errors in your codes and interfaces with our automated software quality assurance geared toward higher ROI. To provide the greatest experience for your consumers, we use fine-tuned tools and construct sturdy walls with our penetration testing services.',
        img: quality,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'DevOps Services',
        desc: 'With our well-engineered DevOps services, you can transition to continuous delivery and ensure durable data pipelines and speedier time-to-market. We integrate your existing infrastructure into a strong ecosystem using agile approaches while maintaining software quality.',
        img: devops,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'Support & Maintenance',
        desc: "Deliver high-performance software to your customers by choosing our advanced web app development strategy, which includes bug-fixing, on-call production support, product improvements, user support, and training. Use Codezone's qualified personnel to optimize the functionalities of your product.",
        img: support,
        link : '/software-development'

    },
]
}

export const DevelopmentServicesData = {
    title1: 'A Wide Range of Ebook Writing ',
    title2: 'Development Services',
    desc: 'Light years ahead of our competitors, CodeZone offers Ebook Writing  development services and uses the latest technologies that will compel your customers to spend lavishly on your products.',
    cards: [
        {
            title: 'Self-publishing',
            desc: 'Self-published authors need to create professional-looking ebook covers to attract readers and compete with traditionally published authors.',
            img: supplyChain
        },
        {
            title: 'Traditional Publishing',
            desc: 'Traditional publishing houses also invest in ebook cover design to ensure their books stand out and appeal to readers.',
            img: progressive
        },
        {
            title: 'Marketing and Advertising',
            desc: 'Ebook covers are an essential part of any book marketing campaign, as they are used to promote the book on social media, online marketplaces, and other platforms.',
            img: enterprise
        },
        {
            title: 'Ebook Design',
            desc: 'Ebook designers may create ebook covers as part of their overall design work, ensuring that the cover matches the style and tone of the rest of the book.',
            img: webConsulting
        },
        {
            title: 'Ebook Retailers',
            desc: 'Ebook retailers may require authors and publishers to provide high-quality ebook covers that meet specific design requirements before selling their ebooks on their platform.',
            img: cloudBased
        },

    ]
}
export const hireWebData = {
    title1: 'Hire Ebook Writing  Developers To Extend',
    title2: 'The Roots of Your Business',
    desc: 'Get ready to elevate the performance and extend the functionalities of your metaverse by hiring our web application developers today!',
    questions: [
        {
            question: 'Good Decision-Making Skills',
            answer: 'Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.',
            img: decision
        },
        {
            question: 'Enriched Experience',
            answer: 'Our senior Ebook Writing  developers, with over 10,000 hours of work on diverse web app development projects, have faced several obstacles, which gives them a broader worldview while presenting answers. Their experiences also provide them with new perspectives on how to approach a project.',
            img: experience
        },
        {
            question: 'Problem Solvers & Risk Managers',
            answer: "Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.",
            img: problemSolver
        },
    ]
}

export const ModelData = {
    title1: 'A Glance At Our Customer-Centric',
    title2: 'Engagement Models',
    desc: 'Choose a business engagement model that best fits your preferences.',
    img,
    tags: ['Resource Augmentation', 'Dedicated Team', 'Fixed Gig']
}

export const techData = {
    title1: 'Our Favorite Folder Of The',
    title2: 'Technologies We Use',
    images: [
        myimg1,
        myimg2,
        myimg3,
        img4,
        img5,
        img6,
        img7,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img22,
        img23,
        img24,


    ]
}

export const reviewData = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [
        {
            title: 'review 1',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 2
        },
        {
            title: 'review 2',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 3.5
        },
        {
            title: 'review 3',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 5,
        },
    ]
}

export const FAQData = [
    {
        question: 'What are some popular ebook genres?',
        answer: 'Popular ebook genres include fiction, non-fiction, self-help, business, and romance.'
    },
    {
        question: 'How long should an ebook be?',
        answer: "The length of an ebook depends on the topic and genre, but most ebooks range from 10,000 to 50,000 words."
    },
]